import { apiGetRequest, apiPutRequest } from 'api/axiosBase';

export const apiGetCategory = () => {
  const requestPayload = { url: '/products/categories' };
  return apiGetRequest(requestPayload);
};

export const apiGetProduct = (payload) => {
  const { productId } = payload;
  const requestPayload = { url: `/products/${productId}` };
  return apiGetRequest(requestPayload);
};

export const apiGetProducts = (payload) => {
  const {
    params = {},
  } = payload;
  const {
    category_id = [], limit = 24, page = 1, keyword = '',
  } = params;
  const requestParams = {
    category_id, limit, page, keyword,
  };
  const requestPayload = { url: '/products', config: { params: requestParams } };
  return apiGetRequest(requestPayload);
};

export const apiGetVariationImages = (payload) => {
  const { productId, params = {} } = payload;
  const requestPayload = { url: `/products/${productId}/variation-images`, config: { params } };
  return apiGetRequest(requestPayload);
};

export const apiUpdateVariationImages = (payload) => {
  const { productId, variationId, bodyData } = payload;
  const requestPayload = { url: `/products/${productId}/variations/${variationId}`, data: bodyData };
  return apiPutRequest(requestPayload);
};
